export const  getCaretCharacterOffsetWithin = (id: any) => {
    if(id){
        const fieldElement = document.getElementById(
          id
        ) as HTMLInputElement;
        let element: any = fieldElement;
        const fourChildNode:any = fieldElement.getElementsByClassName('ck-editor__editable');
        if(fourChildNode && fourChildNode.length){
            element = fourChildNode[0];
        }
        if(element){
        var caretOffset = 0;
        var doc = element?.ownerDocument || element?.document;
        var win = doc?.defaultView || doc?.parentWindow;
        var sel;
        if (typeof win.getSelection != "undefined") {
            sel = win.getSelection();
            if (sel.rangeCount > 0) {
                var range = win.getSelection().getRangeAt(0);
                var preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(element);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                caretOffset = preCaretRange.toString().length;
            }
        } else if ( (sel = doc.selection) && sel.type != "Control") {
            var textRange = sel.createRange();
            var preCaretTextRange = doc.body.createTextRange();
            preCaretTextRange.moveToElementText(element);
            preCaretTextRange.setEndPoint("EndToEnd", textRange);
            caretOffset = preCaretTextRange.text.length;
        }
        return caretOffset;
        }
    }
}